import { DropdownSizes, ListBehaviour } from './dropdown.types';

export const DEFAULT_BEHAVIOUR: ListBehaviour = 'overlay';
export const DEFAULT_SIZE: DropdownSizes = 'l';
